// extracted by mini-css-extract-plugin
export default {"icon":"Administracion_icon__2Hes4","name":"Administracion_name__k8SzR","nuevo":"Administracion_nuevo__xPX2V"};